import { IdeaAttachment, IdeaTier } from '@/types/service/ideaExchange';

import { httpRequest } from '@/services/httpRequest';

export async function downloadIdeaAttachment(
  requestId: number,
  tier: IdeaTier,
  attachment: IdeaAttachment,
): Promise<void> {
  const { data } = await httpRequest({
    url: `/v1/protected/idea-exchange/requests/${requestId}/attachments/${attachment.id}?tier=${tier}`,
    method: 'GET',
    responseType: 'blob',
  });
  const url = URL.createObjectURL(data as Blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = attachment.file_name;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}

export async function ideaAttachmentErrorMessage(error: unknown): Promise<string> {
  const fallback = 'Could not download this file. Reload the request and try again.';
  if (typeof error !== 'object' || error === null || !('response' in error)) return fallback;
  const { response } = error as { response?: { data?: unknown } };
  if (!(response?.data instanceof Blob)) return fallback;
  try {
    const body: unknown = JSON.parse(await response.data.text());
    if (typeof body === 'object' && body !== null && 'detail' in body) {
      return typeof body.detail === 'string' ? body.detail : fallback;
    }
  } catch {
    return fallback;
  }
  return fallback;
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} bytes`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
